import { HeadersWithoutApiKeyWorkaround } from './constants';
import createUploadRequest from '~/graphql/mutations/createUploadRequest';
import axios from 'axios';

// PUBLIC
export async function performImageUploadIfNeeded(imageData) {
    if (!imageData) {
        return null;
    }

    const uploadRequestResponse = await performUploadRequestMutation.bind(this)('IMAGE', false);
    const uploadConfig = prepareFileUploadConfig(uploadRequestResponse, imageData);
    return await performUpload(uploadConfig);
}

export async function performAudioUploadIfNeeded(audioData) {
    if (!audioData) {
        console.log('performAudioUploadIfNeeded | No audio data');
        return null;
    }

    const uploadRequestResponse = await performUploadRequestMutation.bind(this)('AUDIO', false);
    const uploadConfig = prepareFileUploadConfig(uploadRequestResponse, audioData);
    return await performUpload(uploadConfig);
}

// PRIVATE

async function performUploadRequestMutation(assetType, needsTranscoding) {
    let request = {
        mutation: createUploadRequest.createUploadRequest,
        variables: { assetType, needsTranscoding },
    };

    if (this.app.$auth.loggedIn) {
        request = { ...request, context: HeadersWithoutApiKeyWorkaround };
    }

    return this.app.apolloProvider.defaultClient.mutate(request);
}

function prepareFileUploadConfig(uploadRequestResponse, data) {
    let config = {
        protocol: 'https',
        method: uploadRequestResponse.data.createUploadRequest.httpMethod,
        headers: uploadRequestResponse.data.createUploadRequest.headers.reduce((headers, header) => {
            headers[header.key] = header.value;
            return headers;
        }, {}),
        url: uploadRequestResponse.data.createUploadRequest.url,
        fileName: uploadRequestResponse.data.createUploadRequest.fileName,
        provider: uploadRequestResponse.data.createUploadRequest.provider,
    };

    if (uploadRequestResponse.data.createUploadRequest.kind === 'MULTIPART_FORM') {
        const form = new FormData();
        form.append(uploadRequestResponse.data.createUploadRequest.fileParameterName, new Blob([data]), uploadRequestResponse.data.createUploadRequest.fileName);

        uploadRequestResponse.data.createUploadRequest.parameters.forEach((parameter) => {
            form.append(parameter.key, parameter.value);
        });

        config.headers['Content-Type'] = 'multipart/form-data';
        config.data = form;
    } else {
        config.data = data;
    }

    return config;
}

async function performUpload(uploadConfig) {
    await axios.request(uploadConfig);
    return uploadConfig;
}
